import type { ConceptDef } from '../types';

export const sequenceMonths: ConceptDef = {
  kind: 'sequenceTap',
  id: 'sequence-months',
  label: 'Sequence Months of Year',
  category: 'Sequencing',
  description: 'Tap months in order.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Months of the year.', items: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] },
    ],
  },
};
